(() => {
  const root = document.querySelector('[data-pcna-options]');
  if (!root) return;
  const form = root.closest('form');
  const read = selector => JSON.parse(root.querySelector(selector).textContent || 'null');
  const catalogue = read('[data-pcna-catalogue]') || {};
  const shipping = read('[data-pcna-shipping]') || {};
  const variants = read('[data-pcna-variants]') || [];
  const strings = read('[data-pcna-strings]');
  const decorationPrices = catalogue.checkoutDecorations;
  const configPricing = catalogue.configPricing;
  let benchmarkQuantity;
  let initialConfiguration;
  if (configPricing) {
    const selectedId = String(form.querySelector('select[name="id"]')?.value);
    for (const [q, methodMap] of Object.entries(configPricing.variantByQuantity)) {
      for (const [mid, modeMap] of Object.entries(methodMap)) {
        for (const [mode, skuMap] of Object.entries(modeMap)) {
          for (const [sku, id] of Object.entries(skuMap)) {
            if (String(id) === selectedId) initialConfiguration = {q,mid,mode,sku};
          }
        }
      }
    }
  }
  const colours = catalogue.colours || [];
  const methods = catalogue.methods || [];
  const methodSelect = root.querySelector('[data-pcna-method]');
  const primary = root.querySelector('[data-pcna-location]');
  const secondary = root.querySelector('[data-pcna-location2]');
  const ink = root.querySelector('[data-pcna-ink]');
  const inkDetails = root.querySelector('[data-pcna-ink-details]');
  const addLocation = root.querySelector('[data-pcna-second-location]');
  const mixColours = root.querySelector('[data-pcna-mix-colours]');
  const quoteBox = root.querySelector('[data-pcna-quote]');
  const quoteLink = root.querySelector('[data-pcna-quote-link]');
  const gallery = document.querySelector('[data-pcna-gallery]');
  let currentLocations = [];
  let requiresQuote = false;
  let selectedSku = '';
  let mandatoryFeesReady = false;
  const setCartState = () => form.querySelectorAll('[name="add"]').forEach(button => {
    button.hidden = requiresQuote;
    button.disabled = requiresQuote || !mandatoryFeesReady || selectedVariant()?.available === false;
  });
  const selectedColour = () => colours.find(c => c.sku === root.querySelector('input[name="neps_pcna_colour"]:checked')?.value);
  const selectedVariant = () => variants.find(v => String(v.id) === String(form.querySelector('select[name="id"]')?.value)) || variants[0];
  const method = () => methods.find(m => m.id === methodSelect.value);
  const configurationMethod = () => methodSelect.value === 'included' ? configPricing?.defaultMethodId : methodSelect.value;
  const configurationRates = () => configPricing?.methods[configurationMethod()]?.modes[ink.value];
  const option = (value, label) => new Option(label, value);
  const dispatch = element => {
    element.dispatchEvent(new Event('input', { bubbles: true }));
    element.dispatchEvent(new Event('change', { bubbles: true }));
  };
  const syncLegacyFields = () => {
    const boldOptions = form.querySelector('.bold_options');
    if (boldOptions && root.nextElementSibling !== boldOptions) root.after(boldOptions);
    if (boldOptions && root.querySelector('[data-reef-unit-price]')) {
      const heading = boldOptions.querySelector('.bold_option_product_title');
      if (heading && heading.textContent !== strings.uploadArtwork) heading.textContent = strings.uploadArtwork;
    }
    const fees = ['properties[Product setup]', 'properties[Inbound shipping and handling]'];
    mandatoryFeesReady = fees.every(name => {
      const property = Array.from(form.querySelectorAll('input')).find(e => e.name === name);
      const wrapper = property?.closest('.bold_option');
      const checkbox = wrapper?.querySelector('input[type=checkbox]');
      if (!checkbox) return false;
      if (!checkbox.checked) checkbox.click();
      wrapper.hidden = true;
      return checkbox.checked;
    });
    const colour = selectedColour();
    const fields = [
      ['properties[Preferred product colour]', colour?.name || 'Please confirm available colour'],
      ['properties[Imprint colour and placement]', [methodSelect.selectedOptions[0]?.textContent, ink.selectedOptions[0]?.textContent, inkDetails.value.trim(), primary.selectedOptions[0]?.textContent, addLocation.checked ? 'Additional location: ' + secondary.selectedOptions[0]?.textContent : ''].filter(Boolean).join(' · ')]
    ];
    fields.forEach(([name, value]) => {
      const input = Array.from(form.querySelectorAll('input')).find(e => e.name === name);
      if (!input) return;
      const wrapper = input.closest('.bold_option');
      if (wrapper) wrapper.hidden = true;
      else input.style.display = 'none';
      if (input.value !== value) {
        input.value = value;
        dispatch(input);
      }
    });
  };
  const setPhoto = button => {
    if (!gallery || !button) return;
    const hero = gallery.querySelector('.neps-pcna-hero');
    hero.src = button.dataset.image;
    hero.removeAttribute('srcset');
    hero.alt = button.dataset.alt || '';
    gallery.querySelector('[data-pcna-full-image]').href = button.dataset.full;
    gallery.querySelectorAll('[data-pcna-thumb]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
  };
  const updateGallery = sku => {
    if (!gallery) return;
    const thumbs = Array.from(gallery.querySelectorAll('[data-pcna-thumb]'));
    const matched = thumbs.filter(b => catalogue.photoColours?.[b.dataset.alt] === sku);
    thumbs.forEach(b => { b.hidden = matched.length > 0 && !matched.includes(b); });
    const previewId = catalogue.previewPhotoBySKU?.[sku]?.mediaId?.split('/').pop();
    const media = JSON.parse(gallery.querySelector('[data-pcna-all-images]')?.textContent || '[]');
    const previewMedia = media.find(m => String(m.id) === previewId);
    const source = previewMedia?.preview_image?.src || previewMedia?.src;
    const exact = source ? matched.find(b => new URL(b.dataset.image, location.origin).pathname === new URL(source, location.origin).pathname) : null;
    const first = exact || matched.find(b => /blank front view/i.test(b.dataset.alt)) || matched.find(b => /front view/i.test(b.dataset.alt)) || matched[0] || thumbs[0];
    setPhoto(first);
  };
  const updateLocations = () => {
    const sku = selectedColour()?.sku;
    const chosen = method() || methods.find(m => m.id === configPricing?.defaultMethodId) || methods[0];
    const seen = new Set();
    currentLocations = (chosen?.locations || []).filter(l => {
      if (l.sku && l.sku !== sku) return false;
      const key = [l.name, l.widthIn, l.heightIn].join('|');
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
    const prior = primary.value;
    const priorSecond = secondary.value;
    [primary, secondary].forEach(select => {
      select.replaceChildren();
      if (methodSelect.value === 'included' && select === primary) select.add(option('default', strings.defaultLocation));
      currentLocations.forEach(l => select.add(option(l.id, l.name)));
      if (!select.options.length) select.add(option('default', strings.defaultLocation));
    });
    if (Array.from(primary.options).some(o => o.value === prior)) primary.value = prior;
    if (Array.from(secondary.options).some(o => o.value === priorSecond)) secondary.value = priorSecond;
    if (secondary.value === primary.value && secondary.options.length > 1) secondary.selectedIndex = (primary.selectedIndex + 1) % secondary.options.length;
    if (configPricing) {
      const previousInk = ink.value;
      const priced = configPricing.methods[configurationMethod()];
      ink.replaceChildren(...Object.keys(priced?.modes || {}).map(value => option(value, value === '1' ? strings.oneColour : value)));
      if (Array.from(ink.options).some(o => o.value === previousInk)) ink.value = previousInk;
      const embroidery = /embroidery/i.test(chosen?.name || '');
      root.querySelector('label[for="' + ink.id + '"]').textContent = embroidery ? 'Embroidery stitch count' : 'Imprint colours';
      addLocation.closest('label').hidden = currentLocations.length < 2;
      if (currentLocations.length < 2) addLocation.checked = false;
      inkDetails.required = ink.value !== 'Full colour';

      return;
    }
    if (decorationPrices) {
      const digital = chosen?.id === decorationPrices.digital?.methodId;
      addLocation.closest('label').hidden = digital;
      if (digital) addLocation.checked = false;
      ink.replaceChildren(option(digital ? 'Full colour' : '1', digital ? strings.fullColour : strings.oneColour));
      return;
    }
    const laser = methodSelect.value !== 'included' && /laser|deboss|emboss|dome/i.test(chosen?.name || '');
    if (laser) {
      ink.replaceChildren(option('Not applicable', strings.laser));
      inkDetails.required = false;
    } else if (ink.options.length === 1) {
      const original = root.dataset.inkChoices ? JSON.parse(root.dataset.inkChoices) : [];
      ink.replaceChildren(...original.map(o => option(o.value, o.label)));
      inkDetails.required = true;
    }
  };
  const render = () => {
    if (configPricing && benchmarkQuantity) {
      const target = configPricing.variantByQuantity[benchmarkQuantity.value]?.[configurationMethod()]?.[ink.value]?.[selectedColour()?.sku];
      const variant = variants.find(v => String(v.id) === String(target));
      const native = form.querySelector('.single-option-selector[data-index=option1]');
      if (native && variant && native.value !== variant.title) { native.value = variant.title; dispatch(native); }
    }
    if (decorationPrices && benchmarkQuantity) {
      const combined = /both sides|front and back/i.test(primary.selectedOptions[0]?.textContent || '');
      const twoLocations = addLocation.checked || combined;
      const digital = methodSelect.value === decorationPrices.digital?.methodId;
      const priceKey = (digital ? 'digital' : '') + (twoLocations ? '2' : '1');
      const target = decorationPrices.variantByQuantity[benchmarkQuantity.value]?.[priceKey];
      const variant = variants.find(v => String(v.id) === target);
      const native = form.querySelector('.single-option-selector[data-index=option1]');
      if (native && variant && native.value !== variant.title) { native.value = variant.title; dispatch(native); }
    }
    const colour = selectedColour();
    const variant = selectedVariant();
    const sku = colour?.sku || '';
    if (sku !== selectedSku) {
      selectedSku = sku;
      updateGallery(sku);
      updateLocations();
    }
    root.querySelector('[data-pcna-colour-name]').value = colour?.name || '';
    root.querySelector('[data-pcna-second-location-fields]').hidden = !addLocation.checked;
    [secondary, root.querySelector('[data-pcna-art2]')].forEach(e => { e.disabled = !addLocation.checked; });
    root.querySelector('[data-pcna-mix-fields]').hidden = !mixColours.checked;
    [root.querySelector('[data-pcna-colour2]'), root.querySelector('[data-pcna-colour-quantities]')].forEach(e => { e.disabled = !mixColours.checked; });
    const location = primary.value === 'default'
      ? (configPricing ? currentLocations[0] : currentLocations.find(l => /centered on front/i.test(l.name)))
      : currentLocations.find(l => l.id === primary.value);
    const secondLocation = addLocation.checked ? currentLocations.find(l => l.id === secondary.value) : null;
    const areaText = l => l?.widthIn && l?.heightIn
      ? l.name + ': ' + l.widthIn + '″ W × ' + l.heightIn + '″ H'
      : '';
    const areas = [areaText(location), areaText(secondLocation)].filter(Boolean);
    root.querySelector('[data-pcna-area]').textContent = areas.length
      ? 'Maximum imprint area — ' + areas.join(' · ') + '. Artwork is scaled proportionally; final size is confirmed in your proof.'
      : 'Imprint dimensions will be confirmed before production.';
    const orderArea = root.querySelector('[data-pcna-order-area]');
    if (orderArea) orderArea.value = areas.join(' · ');
    const methodName = root.querySelector('[data-pcna-method-name]');
    if (methodName) methodName.value = (method() || methods[0])?.name || '';
    const order = shipping.orderQuantities?.[String(variant?.id)];
    const packing = order?.byColour?.[sku];
    const totalWeight = packing?.estimatedPackedWeightLb;
    root.querySelector('[data-pcna-packing]').textContent = packing ? strings.packing.replace('%cartons%', packing.cartons).replace('%weight%', totalWeight) : strings.packingUnknown;
    root.querySelector('[data-pcna-cartons]').value = packing?.cartons || 'Confirm carton count';
    root.querySelector('[data-pcna-carton-details]').value = packing ? `${packing.carton.height} × ${packing.carton.width} × ${packing.carton.depth} in; ${packing.carton.weightLb} lb per carton; ${packing.carton.packQty} pieces per carton` : 'Supplier carton data requires confirmation';
    root.querySelector('[data-pcna-weight-basis]').value = order?.basis || 'Shipping weight requires confirmation';
    const quantity = Number(variant?.title?.split(' - ')[0]);
    const unitPrice = root.querySelector('[data-reef-unit-price]');
    if (unitPrice && quantity > 0) {
      document.body.classList.add('neps-reef-unit-mode');
      const displayedTotal = (Number(variant.price) + 4500) / 100;
      const money = value => new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD', currencyDisplay: 'narrowSymbol' }).format(value);
      unitPrice.textContent = money(displayedTotal / quantity);
      root.querySelector('[data-reef-order-price]').textContent = money(displayedTotal);
    }

    const digitalPriced = variant?.title?.includes(' - Digital');
    const twoPricedLocations = / - (2 locations|Digital 2 locations)/.test(variant?.title || '');
    const pricedLocationCount = twoPricedLocations ? 2 : 1;
    const additionalPrice = !decorationPrices ? 0 : digitalPriced ? decorationPrices.digital.runPerPiecePerLocationG_CAD * quantity * pricedLocationCount + (twoPricedLocations ? decorationPrices.digital.additionalLocationSetupG_CAD : 0) : twoPricedLocations ? decorationPrices.additionalLocationSetupCAD + decorationPrices.additionalLocationRunCAD * quantity : 0;
    const publicPrices = catalogue.publicRetailCAD?.[sku] || [];
    const priceTier = publicPrices.filter(t => t.quantity <= quantity).sort((a, b) => b.quantity - a.quantity)[0];
    const priceMismatch = priceTier && Math.abs(Math.round((priceTier.price * quantity + additionalPrice) * 100) - Number(variant?.price)) > 1;
    const differentMethod = methodSelect.value !== 'included';
    const multiLocation = /both sides|front and back|front & back/i.test(location?.name || '');
    requiresQuote = !colour || !order?.checkoutWeightLb || shipping.requiresCartonReview === true || addLocation.checked || mixColours.checked || differentMethod || primary.value !== 'default' || !['1', 'Not applicable'].includes(ink.value) || multiLocation || priceMismatch || (publicPrices.length > 0 && !priceTier);
    if (decorationPrices) {
      const screen = methodSelect.value === 'included' || methodSelect.value === decorationPrices.methodId;
      const digital = methodSelect.value === decorationPrices.digital?.methodId && decorationPrices.digital?.checkoutAllowed;
      const primaryName = primary.selectedOptions[0]?.textContent || '';
      const secondaryName = secondary.selectedOptions[0]?.textContent || '';
      const ordinary = /centered on (front|back)$/i;
      const primaryAllowed = primary.value === 'default' || ordinary.test(primaryName) || multiLocation || /seamless wrap/i.test(primaryName);
      // The included/default imprint is the verified front location.
      const effectivePrimaryName = primary.value === 'default'
        ? currentLocations.find(l => /^centered on front$/i.test(l.name))?.name || ''
        : primaryName;
      const extraAllowed = !addLocation.checked || (!multiLocation && ordinary.test(effectivePrimaryName) && ordinary.test(secondaryName) && effectivePrimaryName.toLowerCase() !== secondaryName.toLowerCase());
      requiresQuote = !colour || !order?.checkoutWeightLb || shipping.requiresCartonReview === true || mixColours.checked || (!screen && !digital) || (digital ? ink.value !== 'Full colour' : ink.value !== '1') || !primaryAllowed || !extraAllowed || priceMismatch || !priceTier;
      const chargeNote = root.querySelector('[data-pcna-decoration-charges]');
      chargeNote.hidden = !twoPricedLocations && !digitalPriced;
      chargeNote.textContent = digitalPriced ? strings.digitalCharges.replace('%setup%', (twoPricedLocations ? decorationPrices.digital.additionalLocationSetupG_CAD : 0).toFixed(2)).replace('%run%', decorationPrices.digital.runPerPiecePerLocationG_CAD.toFixed(2)).replace('%locations%', pricedLocationCount).replace('%quantity%', quantity).replace('%total%', additionalPrice.toFixed(2)) : strings.additionalCharges.replace('%setup%', decorationPrices.additionalLocationSetupCAD.toFixed(2)).replace('%run%', decorationPrices.additionalLocationRunCAD.toFixed(2)).replace('%quantity%', quantity).replace('%total%', additionalPrice.toFixed(2));
    }
    if (configPricing) {
      const rates = configurationRates();
      const expected = priceTier && rates ? Math.round((quantity * (priceTier.price + rates.run) + rates.setupAdjustment) * 100) : null;
      requiresQuote = !colour || !location?.widthIn || !location?.heightIn || !order?.checkoutWeightLb || shipping.requiresCartonReview === true || mixColours.checked || addLocation.checked || expected === null || Math.abs(expected - Number(variant?.price)) > 1;
      const chargeNote = root.querySelector('[data-pcna-decoration-charges]');
      chargeNote.hidden = !addLocation.checked && rates?.run === 0 && rates?.setupAdjustment === 0;
      chargeNote.textContent = rates ? 'Included in the product total: ' + new Intl.NumberFormat('en-CA', {style:'currency',currency:'CAD'}).format(rates.run) + ' decoration per piece' + (rates.setupAdjustment ? ' and $52.50 for the full-colour setup upgrade.' : '.') + (/embroidery/i.test(method()?.name || '') ? ' Up to 12 thread colours. Final stitch count is confirmed in your proof.' : '') + (addLocation.checked ? ' Additional-location setup must be confirmed before ordering; please request a quote.' : '') : '';
      inkDetails.required = ink.value !== 'Full colour';
      const chartMoney = value => new Intl.NumberFormat('en-CA', {style:'currency',currency:'CAD',currencyDisplay:'narrowSymbol'}).format(value);
      document.querySelectorAll('[data-backpack-price-row]').forEach(row => {
        const q = Number(row.dataset.backpackPriceRow);
        const id = configPricing.variantByQuantity[q]?.[configurationMethod()]?.[ink.value]?.[sku];
        const v = variants.find(v => String(v.id) === String(id));
        row.querySelector('[data-backpack-chart-unit]').textContent = v ? chartMoney((Number(v.price) / 100 + 45) / q) : 'Enquire';
        row.querySelector('[data-backpack-chart-total]').textContent = v ? chartMoney(Number(v.price) / 100 + 45) : 'Enquire';
      });
      const chartSelection = document.querySelector('[data-backpack-chart-selection]');
      if (chartSelection) chartSelection.textContent = [colour?.name, configPricing.methods[configurationMethod()]?.name, ink.selectedOptions[0]?.textContent].filter(Boolean).join(' · ');
    }
    quoteBox.hidden = !requiresQuote;
    setCartState();
    const details = [document.querySelector('h1')?.textContent?.trim(), 'Product: ' + catalogue.style, 'Order quantity: ' + variant?.title, 'Product colour: ' + colour?.name, 'Decoration: ' + methodSelect.selectedOptions[0]?.textContent, 'Imprint colours: ' + ink.selectedOptions[0]?.textContent, 'Ink details: ' + inkDetails.value, 'Primary location: ' + primary.selectedOptions[0]?.textContent];
    if (addLocation.checked) details.push('Additional location: ' + secondary.selectedOptions[0]?.textContent, 'Additional artwork notes: ' + root.querySelector('[data-pcna-art2]').value);
    if (mixColours.checked) details.push('Second product colour: ' + root.querySelector('[data-pcna-colour2]').value, 'Colour quantities: ' + root.querySelector('[data-pcna-colour-quantities]').value);
    details.push('Product page: ' + window.location.origin + window.location.pathname, strings.quoteInstruction);
    quoteLink.href = 'mailto:info@neps.ca?subject=' + encodeURIComponent(strings.quoteSubject + ' — ' + catalogue.style) + '&body=' + encodeURIComponent(details.join('\n'));
    syncLegacyFields();
    setCartState();
  };
  root.dataset.inkChoices = JSON.stringify(Array.from(ink.options).map(o => ({ value: o.value, label: o.textContent })));
  form.querySelectorAll('.single-option-selector').forEach(select => {
    const wrapper = select.closest('.selector-wrapper');
    if (wrapper) root.before(wrapper);
  });
  if (decorationPrices || configPricing) {
    const native = form.querySelector('.single-option-selector[data-index=option1]');
    if (native) {
      native.closest('.selector-wrapper').hidden = true;
      const label = document.createElement('label');
      label.htmlFor = 'pcna-benchmark-quantity';
      label.textContent = strings.orderQuantity;
      benchmarkQuantity = document.createElement('select');
      benchmarkQuantity.id = label.htmlFor;
      Object.keys((configPricing || decorationPrices).variantByQuantity).forEach(q => benchmarkQuantity.add(option(q, q)));
      benchmarkQuantity.value = selectedVariant()?.title?.split(' - ')[0] || '25';
      root.prepend(label, benchmarkQuantity);
      benchmarkQuantity.addEventListener('change', render);
      if (selectedVariant()?.title?.includes(' - 2 locations')) root.dataset.initialTwoLocations = 'true';
    }
  }
  if (!configPricing) methodSelect.add(option('included', strings.defaultMethod));
  methods.forEach(m => methodSelect.add(option(m.id, m.name)));
  if (configPricing) {
    methodSelect.value = initialConfiguration?.mid || configPricing.defaultMethodId;
    const colourInput = Array.from(root.querySelectorAll('input[name="neps_pcna_colour"]')).find(input => input.value === initialConfiguration?.sku);
    if (colourInput) colourInput.checked = true;
  }
  if (decorationPrices && selectedVariant()?.title?.includes(' - Digital')) {
    methodSelect.value = decorationPrices.digital.methodId;
    if (selectedVariant()?.title?.includes('Digital 2')) root.dataset.initialTwoLocations = 'true';
  }
  mixColours.disabled = colours.length < 2;
  if (gallery) {
    const media = JSON.parse(gallery.querySelector('[data-pcna-all-images]')?.textContent || '[]').filter(m => m.media_type === 'image');
    if (media.length > gallery.querySelectorAll('[data-pcna-thumb]').length) {
      const track = gallery.querySelector('.neps-pcna-thumbnails');
      track.replaceChildren();
      media.forEach(m => {
        const source = m.preview_image?.src || m.src;
        if (!source) return;
        const sized = width => { const url = new URL(source, window.location.origin); url.searchParams.set('width', width); return url.href; };
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.pcnaThumb = '';
        button.dataset.alt = m.alt || '';
        button.dataset.image = sized(800);
        button.dataset.full = sized(1600);
        button.setAttribute('aria-label', m.alt || document.querySelector('h1')?.textContent || 'Product image');
        button.setAttribute('aria-pressed', 'false');
        const image = document.createElement('img');
        image.src = sized(130);
        image.alt = m.alt || '';
        image.loading = 'lazy';
        button.append(image);
        track.append(button);
      });
    }
  }
  gallery?.querySelectorAll('[data-pcna-thumb]').forEach(b => b.addEventListener('click', () => setPhoto(b)));
  methodSelect.addEventListener('change', () => { updateLocations(); render(); });
  root.addEventListener('change', render);
  inkDetails.addEventListener('input', render);
  root.querySelector('[data-pcna-art2]').addEventListener('input', render);
  root.querySelector('[data-pcna-colour-quantities]').addEventListener('input', render);
  form.querySelectorAll('.single-option-selector').forEach(e => e.addEventListener('change', () => requestAnimationFrame(render)));
  form.addEventListener('submit', event => { syncLegacyFields(); if (requiresQuote || !mandatoryFeesReady) { event.preventDefault(); event.stopImmediatePropagation(); quoteBox.scrollIntoView({ block: 'center', behavior: 'smooth' }); } }, true);
  form.addEventListener('click', event => { if (requiresQuote && event.target.closest('[name="add"]')) { event.preventDefault(); event.stopImmediatePropagation(); } }, true);
  let legacySyncPending = false;
  const legacyObserver = new MutationObserver(() => {
    if (legacySyncPending) return;
    legacySyncPending = true;
    requestAnimationFrame(() => {
      legacySyncPending = false;
      // Our own heading/move updates must not trigger another synchronization.
      legacyObserver.disconnect();
      try { syncLegacyFields(); setCartState(); }
      finally { legacyObserver.observe(form, { childList: true, subtree: true }); }
    });
  });
  updateLocations();
  if (initialConfiguration && Array.from(ink.options).some(o => o.value === initialConfiguration.mode)) ink.value = initialConfiguration.mode;
  if (root.dataset.initialTwoLocations === 'true') {
    const bothSides = Array.from(primary.options).find(o => /both sides|front and back/i.test(o.textContent));
    if (bothSides) primary.value = bothSides.value;
  }
  render();
  legacyObserver.observe(form, { childList: true, subtree: true });
})();



